import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import * as moment from 'moment';

import { AiOutlineSearch } from "react-icons/ai";
import Spinner from '../../../../../components/Spinner'
import { Header, TableWrapper, TableSection, SearchWrapper } from '../../DashBoard/dashBoardStyled'
//table
import { Table } from 'reactstrap';
import CsvDownloader from 'react-csv-downloader';
import { MdKeyboardBackspace } from "react-icons/md";
import Pagination from '@material-ui/lab/Pagination';

function PostLoadReport() {
    let history = useHistory();
    let location = useLocation();
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const [dataList, setDataList] = useState([]);
    const [finalData, setFinalData] = useState([])
    const [csvData, setCsvData] = useState([])
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [title, setTitle] = useState('')
    const [tableSearch, setTableSearch] = useState('')
    const [headerArr, setHeaderArr] = useState([
        { title: 'Email', },
        { title: 'Company Name', },
        { title: 'City', },
        { title: 'State', },
        { title: 'Zip', },
        { title: 'FC Member', },
        { title: 'Broker', },
        { title: 'Posted Date', }
    ])

    //for csv download
    const [columns, setColumns] = useState([
        { id: 'Email', displayName: 'Email' },
        { id: 'CompanyName', displayName: 'Company Name' },
        { id: 'City', displayName: 'City' },
        { id: 'State', displayName: 'State' },
        { id: 'Zip', displayName: 'Zip' },
        { id: 'FCMember', displayName: 'FC Member' },
        { id: 'Broker', displayName: 'Broker' },
        { id: 'PostedDate', displayName: 'Posted Date' }
    ])

    useEffect(() => {
        if (location.state !== null && location.state !== undefined) {

            let tempData = location.state.data
            let filters = location.state.filters
            if (filters.postType === 'postLoad') {
                setTitle('Post Need Report')
                let temp1 = JSON.parse(JSON.stringify(headerArr))
                temp1.splice(7, 0, { title: 'Post Need Count', })
                setHeaderArr(temp1)
                let temp2 = JSON.parse(JSON.stringify(columns))
                temp2.splice(7, 0, { id: 'Count', displayName: 'Post Need Count' })
                setColumns(temp2)
            }
            if (filters.postType === 'postInventory') {
                setTitle('Post Inventory Report')
                let temp1 = JSON.parse(JSON.stringify(headerArr))
                temp1.splice(7, 0, { title: 'Post Inventory Count', })
                setHeaderArr(temp1)
                let temp2 = JSON.parse(JSON.stringify(columns))
                temp2.splice(7, 0, { id: 'Count', displayName: 'Post Inventory Count' })
                setColumns(temp2)
            }
            let tempDataSorted = tempData.sort((a, b) => b.createdAtUTC - a.createdAtUTC)
            //set csv data
            csvfunction(tempDataSorted)
            // let tempCsvData = tempDataSorted.map(val => {
            //     return ({
            //         Email: val.email,
            //         CompanyName: val.shipperName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
            //         City: val.shippingAddress.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
            //         State: val.shippingAddress.state?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
            //         Zip: val.shippingAddress.zip?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
            //         FCMember: val.innerCircle ? 'Yes' : 'No',
            //         Broker: val.isReseller ? 'Yes' : 'No',
            //         Count: val.count,
            //         PostedDate: val.createdAtUTC ? moment(val.createdAtUTC * 1000).format("MM/DD/YYYY") : 'NA'
            //     })
            // })
            // setCsvData(tempCsvData)

            if (tempDataSorted !== null) setDataList(tempDataSorted)
            //pagination
            let pageData = JSON.parse(JSON.stringify(tempDataSorted))
            setFinalData(pageData.splice(page * 10 - 10, 10))
            if (tempDataSorted.length % 10 === 0) {
                setPageCount(tempDataSorted.length / 10)
            } else {
                setPageCount(Math.trunc(tempDataSorted.length / 10) + 1)
            }
        } else {
            history.push({
                pathname: '/reports',
                state: { page: 'post' }
            })
        }
    }, []);

    const handleChange = (event, value) => {
        setPage(value);
        const search = tableSearch
        let dataListtemp = dataList.filter(value => {
            return (
                (value.email && value.email.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shipperName && value.shipperName.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shippingAddress && value.shippingAddress.city && value.shippingAddress.city.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shippingAddress && value.shippingAddress.state && value.shippingAddress.state.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shippingAddress && value.shippingAddress.zip && value.shippingAddress.zip.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.count && value.count.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.createdAtUTC && moment(value.createdAtUTC * 1000).format("MM/DD/YYYY").toString().toLowerCase().includes(search.toLowerCase()))
            )
        }
        );
        let pageData = JSON.parse(JSON.stringify(dataListtemp))
        setFinalData(pageData.splice(value * 10 - 10, 10))
    };

    const csvfunction = (getData)=>{
     let tempCsvData = getData.map(val => {
                return ({
                    Email: val.email,
                    CompanyName: val.shipperName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                    City: val.shippingAddress.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                    State: val.shippingAddress.state?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                    Zip: val.shippingAddress.zip?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                    FCMember: val.innerCircle ? 'Yes' : 'No',
                    Broker: val.isReseller ? 'Yes' : 'No',
                    Count: val.count,
                    PostedDate: val.createdAtUTC ? moment(val.createdAtUTC * 1000).format("MM/DD/YYYY") : 'NA'
                })
            })
            setCsvData(tempCsvData)   
    }

    const handleSearchChange = e => {
        e.preventDefault()
        setTableSearch(e.target.value)
        const search = e.target.value
        let dataListtemp = dataList.filter(value => {
            return (
                (value.email && value.email.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shipperName && value.shipperName.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shippingAddress && value.shippingAddress.city && value.shippingAddress.city.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shippingAddress && value.shippingAddress.state && value.shippingAddress.state.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.shippingAddress && value.shippingAddress.zip && value.shippingAddress.zip.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.count && value.count.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.createdAtUTC && moment(value.createdAtUTC * 1000).format("MM/DD/YYYY").toString().toLowerCase().includes(search.toLowerCase()))
            )
        }
        );
        csvfunction(dataListtemp)
        setPage(1)
        if (dataListtemp.length % 10 === 0) {
            setPageCount(dataListtemp.length / 10)
        } else {
            setPageCount(Math.trunc(dataListtemp.length / 10) + 1)
        }
        setFinalData(dataListtemp.splice(0, 10))
    }

    return (
        <TableWrapper>
            {loaderVisible && <Spinner />}
            <MdKeyboardBackspace style={{ width: '28px', height: '28px', position: 'relative', left: '12px', top: '8px', cursor: 'pointer' }}
                onClick={() => {
                    history.push({
                        pathname: '/reports',
                        state: { page: 'post' }
                    })
                }} />
            <Header>
                <h3>{title}</h3>
                <div className='header-search-wrapper-reports'>
                    <SearchWrapper>
                        <input style={{ border: '1px solid #87CDF1', borderRadius: '5px' }} type="text" placeholder='Search' value={tableSearch}
                            onChange={handleSearchChange} />
                        <AiOutlineSearch />
                    </SearchWrapper>
                    <CsvDownloader
                        filename="Post Need/Inventory Report"
                        columns={columns}
                        datas={csvData}>
                        <button
                            style={{ background: '#27911b', color: 'white', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '5px' }}>
                            Export
                        </button>
                    </CsvDownloader>
                </div>
            </Header>
            <TableSection>
                <Table responsive>
                    <thead>
                        <tr>
                            {headerArr.map((items, index) => (
                                <th key={index}>{items.title}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            finalData.map((items, index) => (
                                <tr key={index}>
                                    <td>{items.email}</td>
                                    <td>{items.shipperName}</td>
                                    <td>{items.shippingAddress?.city}</td>
                                    <td>{items.shippingAddress?.state}</td>
                                    <td>{items.shippingAddress?.zip}</td>
                                    <td>{items.innerCircle ? 'Yes' : 'No'}</td>
                                    <td>{items.isReseller ? 'Yes' : 'No'}</td>
                                    <td>{items.count}</td>
                                    <td>{items.createdAtUTC ? moment(items.createdAtUTC * 1000).format("MM/DD/YYYY") : 'NA'}</td>
                                </tr>
                            ))}
                        {finalData.length === 0 &&
                            <p style={{ position: 'absolute', width: '100%', textAlign: 'center', marginTop: '30px' }}>No records found</p>
                        }
                    </tbody>
                </Table>
            </TableSection>
            {dataList.length !== 0 && <Pagination count={pageCount}
                page={page}
                onChange={handleChange} />}

        </TableWrapper>

    )
};

export default PostLoadReport;



